<template>
  <div id="app">
    <div class="container">
      <div class="item">
        <img class="app-logo" src="https://static.wixstatic.com/media/ea94eb_ab751f21eff6434b8aa93d62302bc42d~mv2_d_1796_2088_s_2.png" alt="Freestyle Production Logo">
      </div>
      <div class="header">
        <div class="textGroup">
          <div class="clock meetingID">
            Meeting ID: {{ meetingID }}
          </div>
          <div class="clock">
            {{timeOne}}
          </div>
        </div>
        <div class="presenterControls">
          <div class="presenterUI">
            <button class="uiButtons" :class="isRequestingControl ? 'blink' : 'requestControl'" @click="RequestRemoteControl">Request Control</button>

          </div>
          <div class="presenterUI">
            <button class="uiButtons" :class="isActiveUser ? 'stopControl' : 'disabled'" @click="StopControl">Stop Control</button>

          </div>
        </div>
      </div>
      <div class=" item  backButton shadow-lg" style="background: url('http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp RedBG.png'); background-size: cover" @click="SlideBack" >


        <div :class="isActiveUser ? 'dimLEDRed' : 'disabled'">

          <transition name="backFade"
            v-on:enter="enterRed">
            <div v-if="showRed" class="brightLEDRed"></div>
          </transition>

      </div>
      </div>
      <div class="item-3 item forwardButton shadow-lg" style="background: url('http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBG.png'); background-size: cover" @click="SlideForward" >

            <div :class="isActiveUser ? 'dimLED' : 'disabled'">
              <transition name="fwdFade"
              v-on:enter="enterGreen">
                <div v-if="showGreen" class="brightLED" ></div>
              </transition>
<!--            <div class="brightLED">-->
          <!--        <div class=" shadow forwardButton BGGradient"  @click="SlideForward">-->
<!--              <p style="text-align: left"></p>-->

            </div>
        </div>

      </div>

      </div>

</template>

<script>
  import moment from 'moment';
  import firebase from '../firebase';
  import router from "../router";

  export default {
    name: 'RemoteControl',
    data() {
      return {
        nickname: this.$route.params.nickname,
        meetingID: this.$route.params.meetingID,
        activeUser: false,
        present: true,
        // activeUser: firebase.database.ref(this.$route.params.meetingID + '/' + this.$route.params.userID + '/activeUser'),
        userID: this.$route.params.userID,
        // ref: firebase.database.ref(this.$route.params.meetingID),
        timeOne: moment().format('LT'),
        timeTwo: moment().format('l'),
        timeThree: moment().format('MMMM Do YY'),
        timeFour: moment().format('LT'),
        one: true,
        two: false,
        three: false,
        four: false,
        faded: '',
        instruction: "Click anywhere to change the clock's format",
        showGreen: false,
        showRed: false,
        instructionsStyle: {
          opacity: 1,
          show: false,
          transition: '.2s'
        }

      }
    },
    created: function() {
      // setTimeout(function() {
      this.$store.dispatch('requestControlListenerAction', {fbPath: 'Session/' + this.$route.params.meetingID + '/Users/' + this.$route.params.userID + '/request_control'});
      this.$store.dispatch('requestActiveUserListenerAction', {activeUserPath: 'Session/' + this.$route.params.meetingID + '/Users/' + this.$route.params.userID + '/activeUser'});
      // this.$store.dispatch('logUsersPresence', {fbPath: 'Session/' + this.$route.params.meetingID + '/Users/' + this.$route.params.userID + '/present'});
      // });
      this.$store.dispatch('getFirebaseDatabase');
      window.addEventListener('keydown', this.ClickButton);
      // document.onkeypress = this.SlideForward;

    },
    destroyed() {
      window.removeEventListener('keydown', this.ClickButton);
    },
    methods: {
      ClickButton(e) {
          let cmd = e.key;
          if (cmd === 'ArrowLeft') {
            this.SlideBack()
          } else if (cmd === 'ArrowRight') {
            this.SlideForward()
          } else if (cmd === 'p') {
            this.SlideBack()
          } else if (cmd === 'n') {
            this.SlideForward()
          }
        },
      RequestRemoteControl() {
        this.$store.dispatch('requestRemoteControl', {fbPath: 'Session/' + this.$route.params.meetingID + '/Users/' + this.$route.params.userID + '/request_control'});
      },
      SlideForward() {
        console.log(this.$store.state._activeUser);
        if (this.$store.state._activeUser === true) {
          let newData = firebase.database.ref('/Session/' + this.meetingID)
          newData.update({
            key: 'a',
          });
          this.fwdFade();
          setTimeout(function() {
            newData.update({
              key: '',
            });

          }, 1000);
        }
      },
      SlideBack() {
        if (this.$store.state._activeUser === true) {
          this.backFade();
          let newData = firebase.database.ref('/Session/' + this.meetingID)
          newData.update({
            key: 'b',
          });
          setTimeout(function() {
            newData.update({
              key: '',
            });

          }, 1000);
        }
      },
      RequestControl(evt) {
        evt.preventDefault()

        let newData = firebase.database.ref('chatrooms/' + this.roomid + '/chats').push();
        newData.set({
          type: 'newmsg',
          user: this.nickname,
          message: this.data.message,
          sendDate: Date()
        });
        this.data.message = '';
      },
      ExitSession() {
        let exitData = firebase.database.ref(this.roomid).push()
        exitData.set({
          type: 'exit',
          user: this.nickname,
          message: this.nickname + ' has exited this room.',
          sendDate: Date()
        })

        this.offStatus = true
        router.go(-1)
      },
      toggleMe: function() {
        this.$store.dispatch('toggle');
      },
      StopControl() {
        this.$store.dispatch('StopRemoteControl', {fbPath: 'Session/' + this.$route.params.meetingID + '/Users/' + this.$route.params.userID + '/activeUser'});
      },
      fwdFade: function() {
        this.showGreen = !this.showGreen
      },
      enterGreen: function(el, done) {

        var that = this;

        setTimeout(function() {
          that.showGreen = false;
        }, 1500); // hide the message after 3 seconds
      },
      backFade: function() {
        this.showRed = !this.showRed
      },
      enterRed: function(el, done) {

        var that = this;

        setTimeout(function() {
          that.showRed = false;
        }, 1500); // hide the message after 3 seconds
      },
    },
    computed: {
      isRequestingControl: function() {
        return this.$store.getters.isRequestingControl;

      },
      isTrue: function() {
        return this.$store.getters.isTrue;
      },
      isActiveUser: function() {
        return this.$store.getters.isActiveUser;
      }
    },
    mounted: function() {
      setInterval(()=>{
        this.timeOne = moment().format('LT')
      },30000)
    }
  }

</script>

<style>
  .header {
    display: flex;
    justify-content: space-between;
    height: 75px;
    /*margin-left: 25px;*/
    align-items: stretch;
    /*padding: 0px 30px;*/
  }

  /** {*/
  /*  box-sizing: border-box;*/
  /*}*/

  .fwdFade-enter-active,
  .fwdFade-leave-active {
    transition: opacity .5s
  }

  .fwdFade-enter,
  .fwdFade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  .backFade-enter-active,
  .backFade-leave-active {
    transition: opacity .5s
  }

  .backFade-enter,
  .backFade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  .forwardButton {
    background-size: contain;
    width: auto;
    height: auto;
    position: relative;
    /*perspective: 800px;*/
    margin: auto;
    text-align: left;
    color: #E0E0E0;
  }

  .forwardButton * {
    transition: all .5s ease-out;
    border-radius: 10px;
  }

  .forwardButton:focus {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBright.png");
    z-index: -5;
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .forwardButton .brightLED {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBright.png");
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .forwardButton .dimLED {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenDim.png");
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .backButton .brightLEDRed {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp RedBright.png");
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .backButton .dimLEDRed {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp RedDim.png");
    background-size: contain;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;

  }


  .forwardButton .BGGradient {
    background-size: cover;
    width: 370px;
    height: 348.567px;
    position: absolute;
    background-repeat: no-repeat;
    background-position-x: -50px;
    background-attachment: fixed;

  }

  .forwardButton .band {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBG.png");
    background-size: contain;
    width: 274px;
    height: 358px;
    position: absolute;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  /*.forwardButton:hover .shine {*/
  /*//background-color: #000;*/
  /*  transform: translateY(-100px) rotateX(80deg);*/
  /*}*/

  .forwardButton:hover .forwardButtonface {
  //background-color: #000;
    transform: translateY(-50px) rotateX(80deg);
  }

  .forwardButton:hover .casing {
  //background-color: #000;
    transform: translateY(0px) rotateX(80deg);
  }

  .forwardButton:hover .buttons {
  //background-color: #000;
    transform: translateY(50px) rotateX(80deg);
  }

  .forwardButton:hover .band {
  //background-color: #000;
    transform: translateY(100px) rotateX(80deg);
  }

  /*.forwardButton *:hover {*/
  /*  background-color: rgba(0, 0, 0, .8);*/
  /*}*/

  .forwardButton .active {
    background-color: rgba(0, 0, 0, .8);
    transform: translateX(517px) rotateX(0deg) !important;
  }

  .clear {
    font-size: 20px;
    padding: 0px;
    background: #00008B;
    color: #fff;
    cursor: pointer;
    display: block;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-radius: 25px;
  }

  .clear:hover {
    background: #0000CD;
  }


  .backButton {
    background-size: cover;
    width: auto;
    /*height: 100%;*/
    position: relative;
    /*perspective: 800px;*/
    margin: auto;
    text-align: left;
    color: #E0E0E0;
    background-repeat: no-repeat;
  }

  .backButton * {
    transition: all .5s ease-out;
    border-radius: 10px;
  }

  .backButton:focus {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBright.png");
    z-index: -5;
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  /*.backButton .brightLED {*/
  /*  background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBright.png");*/
  /*  background-size: cover;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*}*/

  /*.backButton .dimLED {*/
  /*  background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenDim.png");*/
  /*  background-size: cover;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  background-position: center;*/
  /*}*/

  .backButton .brightLEDRed {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp RedBright.png");
    background-size: contain;
    width: auto;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  /*.backButton .dimLEDRed {*/
  /*  background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp RedDim.png");*/
  /*  background-size: cover;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*}*/


  .backButton .BGGradient {
    background-size: cover;
    width: 370px;
    height: 348.567px;
    position: absolute;
    background-repeat: no-repeat;
    background-position-x: -50px;
    background-attachment: fixed;

  }

  .backButton .band {
    background: url("http://www.NMRController.Newfangled.Tech/assets/PerfectCueApp GreenBG.png");
    background-size: contain;
    width: 274px;
    height: 358px;
    position: absolute;
  }



  /*.backButton:hover .shine {*/
  /*//background-color: #000;*/
  /*  transform: translateY(-100px) rotateX(80deg);*/
  /*}*/

  .backButton:hover .backButtonface {
  //background-color: #000;
    transform: translateY(-50px) rotateX(80deg);
  }

  .backButton:hover .casing {
  //background-color: #000;
    transform: translateY(0px) rotateX(80deg);
  }

  .backButton:hover .buttons {
  //background-color: #000;
    transform: translateY(50px) rotateX(80deg);
  }

  .backButton:hover .band {
  //background-color: #000;
    transform: translateY(100px) rotateX(80deg);
  }

  /*.backButton *:hover {*/
  /*  background-color: rgba(0, 0, 0, .8);*/
  /*}*/

  .backButton .active {
    background-color: rgba(0, 0, 0, .8);
    transform: translateX(517px) rotateX(0deg) !important;
  }

  .clear {
    font-size: 20px;
    padding: 0px;
    background: #00008B;
    color: #fff;
    cursor: pointer;
    display: block;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-radius: 25px;
  }

  .clear:hover {
    background: #0000CD;
  }



  template {
    font-size: 1.35em;
    font-family: 'Varela Round', sans-serif;
    color: #020202;
    background: #000000;
    padding-left: 5%;
    padding-right: 5%;
  }

  .container {
    display: flex;
    /*flex-direction: row;*/
    flex-basis: 200px;
    max-width: 400px;
    flex-direction: column;
    flex-wrap: wrap;
    height: 650px;
    padding: 10px;

    background: #424242;
    border-radius: 5px;
    margin: 45px auto;
    box-shadow: 0 1.5px 0 0 rgba(0, 0, 0, 0.1);
  }

  .item {
    padding: 15px;
    margin: 5px;
    border-radius: 3px;
    background-color: #424242;
    flex: 1;
  }

  .item-2 {
    flex: 1;
  }


  .item-3 {
    flex: 6;
    /*padding: 0;*/
  }
 .stopControl {
   background-color: rgba(183, 28, 28, 0.51);

 }
  .btnDisabled {
    background-color: #212121;
  }

  .btnExit {
    flex: 1;
    background-color: rgb(198, 40, 40);
  }

  .btnExit:hover {
    background: rgb(150, 0, 0);
  }

  .btnExit:active {
    background: rgb(200, 0, 0);
  }

  .btnBack {
    text-align: left;
  }

  /*.btnBack:hover {*/
  /*  background: rgb(100, 0, 0);*/
  /*}*/

  .btnBack:active {
    background: rgb(183, 28, 28);
  }

  .btnForward {
    text-align: left;
  }

  /*.btnForward:hover {*/
  /*  background: rgb(104, 159, 56);*/
  /*}*/

  .btnForward:active {
    background: rgba(85, 139, 47, 0.57);
    animation: requestControlActive 2s;
  }

  /*.btnForward:active:after {*/
  /*  background: rgb(156, 204, 101);*/
  /*  animation: requestControlActive 0s;*/
  /*}*/

  @keyframes requestControlActive {
    0% {
      background: rgb(124, 179, 66);
    }

    100% {
      background: rgb(85, 139, 47);

    }
  }

  .w150 {
    min-width: 100px;
  }

  .mt20 {
    margin-top: 0px;
  }

  .blink {
    animation: fader 1s infinite;
    -webkit-animation: fader 1s infinite;

    background-color: rgba(55, 106, 136, 1);

  }

  @keyframes fader {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fader {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 1;
    }
  }

  .btn:hover {
    color: #fff !important;
    text-decoration: none;

}

  .requestControl {
    background-color: rgba(55, 106, 136, 0.5);

  }
  #sampleAnimation { max-width: 350px; margin: 20px auto; text-align: center; }
  .alert { margin-top: 20px; }
  button { outline: none !important; }
  .fade-enter { opacity: 0 }
  .fade-enter-active { transition: opacity 2s ease }
  .fade-leave {transition: opacity 2s ease; opacity: 0}
  .fade-leave-active { transition: opacity 2s ease; opacity: 0}

  .disabled {
    background-color: rgba(55, 106, 136, 0.5);
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10+ and Edge */
    user-select: none; /* Standard syntax */
    pointer-events: none;
  }

  .red {
    background: red;
  }

  .blue {
    background: #0277bd;
  }

  .div {
    width: 100px;
    height: 100px;
    display: inline-block;
    border: 1px solid black;
  }

  #content {

    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    color: #fff;
    transition: .5s;
    text-align: center;
    /*font-family: Oxygen;*/
  }

  .wrapper {
    margin-bottom: 50px;
  }

  h1 {
    transition: .2s;
    font-size: 5.5em;
    margin: 0;
  }

  p {
    transition: .2s;
  }

  .faded {
    transition: .2s;
    color: black;
  }
  .clock {
    color: #E0E0E0;
    margin: 0;
    flex-shrink: 1;
    flex-wrap: nowrap;
    /*font-size: .3em;*/
  }
  .meetingID{
    font-size: .6em;
    /*flex-shrink: 5;*/
    align-self: stretch;
    order: 0;
    flex: 0 0 0;
    flex-grow: 0;
    flex-shrink: 1;
    flex-wrap: nowrap;
    /*flex-basis: 90px;*/

  }
  .presenterControls {
    width: auto;
    display: flex;
    justify-content: space-evenly;
    align-self: stretch;

  }

  orgButton {
    height: auto;
    width: auto;
    padding: 0;
    margin:0;
    font-size: .75em;
  }

  orgBButton {
    height: 55%;
    padding: 0;
    margin:4px;
    font-size: 1em;

  }
  .presenterUI {
    align-self: stretch;
    order: 0;
    flex: 0 0 auto;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 90px;
  }

  .uiButtons {
    color: #E0E0E0;
    border: none;
    border-radius: 5px;
    /*padding: 0;*/
    /*margin: 0;*/
    outline: none;
  }
  .uiButtons:focus {
    outline: none;
  }
  .textGroup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 25px;
    align-content: center;
    align-items: flex-start;
  }

.app-logo{
  max-height: 100px;
}

</style>